import { Injectable } from '@angular/core';
import { CodeSettings } from '../common/models/internal/code-settings';
import { ReleaseCodeType } from '../common/enums/release-code-type';
import { environment } from 'src/environments/environment';
import { PMRequestsService } from './pm-requests.service';
import { BehaviorSubject, finalize, take } from 'rxjs';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ReleaseCodeService
{

  codeSettings: CodeSettings = {
    count: 1,
    type: ReleaseCodeType.none,
    prescription: { soundTherapy: false, cbt: false },
    regionId: environment.region,
    withQRcodes: false
    // creator: CreatorType.admin
  }

  constructor(private requestsService: PMRequestsService) { }

  generateReleaseCodes(): BehaviorSubject<boolean>
  {
    let l_loaded = new BehaviorSubject<boolean>(false)
    this.requestsService.generateReleaseCodes(this.codeSettings).pipe(take(1), finalize(() =>
    {
      l_loaded.next(true)
    })).subscribe((data: Blob) =>
    {
      var file = new Blob([data], { type: 'text/html;charset=utf-8' })
      var fileURL = URL.createObjectURL(file);
      let l_date = formatDate(Date.now(), 'yyyy-MM-dd_HH-mm-ss', 'en-US');
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = `$ReleaseCodes_${ l_date }`;
      document.body.appendChild(a);
      a.click();
    },
      (error) =>
      {
        console.error('generateCodesCSV error: ', error);
      }
    );

    return l_loaded
  }
  


  clearAll()
  {
    this.codeSettings = {
      count: 1,
      type: ReleaseCodeType.none,
      prescription: { soundTherapy: false, cbt: false },
      regionId: environment.region,
      withQRcodes: false
      // creator: CreatorType.admin
    }
  }
}
